import React, { useContext, useEffect, useRef } from "react";
import { Login } from "./login";
import { useToken } from "./useToken";

export const AuthContext = React.createContext<ReturnType<typeof useToken>>(
	{} as any,
);

export type AuthConfig = {
	guestIsEnabled: boolean;
	useEmailAndPassword: boolean;
	useAzureAD: boolean;
	useWindowsAuth: boolean;
	AzureConfig: AzureConfig;
};
export type AzureConfig = {
	clientId: string;
	authority: string;
	redirectUri: string;
};

type AuthProviderProps = {
	children: any;
	authConfig: AuthConfig;
};

export const AuthProvider = ({ children, authConfig }: AuthProviderProps) => {
	const useTokenHook = useToken();
	return (
		<>
			<AuthContext.Provider value={useTokenHook}>
				{!!useTokenHook.token && <Authenticated>{children}</Authenticated>}
				{!useTokenHook.token && <Unauthenticated authConfig={authConfig} />}
			</AuthContext.Provider>
		</>
	);
};

const Authenticated = ({ children }: { children: any }) => <>{children}</>;

const Unauthenticated = ({ authConfig }: { authConfig: AuthConfig }) => {
	const { clearUserData } = useContext(AuthContext);
	const params = useRef(new URL(document.location as any).searchParams);

	useEffect(() => {
		clearUserData();
		const newUrl = window.location.origin + "?" + params.current.toString();
		window.history.replaceState({ path: newUrl }, "", newUrl);
	}, []);
	return <Login authConfig={authConfig} />;
};
